<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise = !minimise"></i>
    <i class="fa fa-times" (click)="cancel()"></i>
  </div>
</div>

<!-- Modal Content Wrapper - Everything except header -->
@if (!minimise) {
<div>

<!-- Modal Body -->
<div class="modal-body">
  <div class="form-container">
    <div class="form-group">
      <label for="paymentType">Payment Type</label>
      <select 
        id="paymentType" 
        class="form-control" 
        name="paymentType"
        [(ngModel)]="selectedPaymentType"
        required>
        <option [ngValue]="null">Select</option>
        @for (type of paymentTypes; track $index) {
<option [ngValue]="type">
          {{ type.DESCRIPTION }}
        </option>
}
      </select>
    </div>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button 
    class="save-button" 
    type="button" 
    (click)="savePartyPaymentType()"
    [disabled]="!selectedPaymentType || crudLoading">
    @if (crudLoading) {
<span>
      <i class="fa fa-spinner fa-pulse"></i>
    </span>
}
    Save
  </button>
  <button 
    class="cancel-button" 
    type="button" 
    (click)="cancel()">
    Cancel
  </button>
</div>

</div>
}

